import { Button, ButtonGroup } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  deleteApi,
  getApi,
  postApi,
  putApi,
  sessionExpired,
} from '../../../_redux/_apiHelpers/_apihelper';
import { updateLoader } from '../../../_redux/LoaderSlice';
import { updateSnackbar } from '../../../_redux/SnackbarSlice';
import CustomDynamicTable from '../../../components/DynamicTable/CustomDynamicTable';
import './Custom.css';

import { GetUserId, GetUserInfo } from '../../../_utilities/getUserInfo';
const Custom = () => {
  const [customPostingsFeilds, setCustomPostingsFeilds] = useState([]);
  const [customApplicantsFeilds, setCustomApplicantsFeilds] = useState([]);
  const [customClientsFeilds, setCustomClientsFeilds] = useState([]);
  const [moduleType, setModuleType] = useState('Job Postings');
  const [getUserId, setUserId] = useState(null);

  const dispatch = useDispatch();
  const initialSnackbar = { type: '', message: '' };


  useEffect(() => {
    async function init() {
      const userIdData = await GetUserId();
      setUserId(userIdData);
      fetchData(userIdData);
    }
    init();
  }, []);

  const fetchData = async (id) => {
    try {
      setCustomPostingsFeilds([]);
      setCustomApplicantsFeilds([]);
      setCustomClientsFeilds([]);
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));
      const res = await getApi(
        `/mgmt/customer/${id}/customfields?atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      let Data = res.data;
      const myData = Data.customfeilds;
      if (Data.code === 200) {
        if (myData !== undefined && myData.length > 0) {
          dispatch(updateLoader(false));
          // for jobpostings
          let postingRecords = myData.filter((x) => parseInt(x.moduleId) === 1);
          let defaultPostingRecords = postingRecords.filter(
            (x) => x.fieldType === 'default'
          );
          let customPostingRecords = postingRecords.filter(
            (x) => x.fieldType === 'custom'
          );
          let hash = Object.create(null);
          const uniqueDefaultPostingRecords = defaultPostingRecords.reduce(
            function (r, o) {
              if (!(o.fieldName in hash)) {
                hash[o.fieldName] = r.push(o) - 1;
                return r;
              }
              if (o.id > r[hash[o.fieldName]].id) {
                r[hash[o.fieldName]] = o;
              }
              return r;
            },
            []
          );

          let postingObj = JSON.parse(JSON.stringify(defaultPostingsData));
          uniqueDefaultPostingRecords.forEach((list) => {
            let index = postingObj.findIndex(
              (x) => x.fieldName === list.fieldName
            );
            if (index !== -1) {
              postingObj[index].customValues = JSON.parse(list.customValues);
              postingObj[index].id = Number(list.id);

              if (list.searchableField !== undefined) {
                postingObj[index].searchableField = Number(
                  list.searchableField
                );
              }
              if (list.mandatory !== undefined) {
                postingObj[index].mandatory = Number(list.mandatory);
              }
            }
          });
          // normalize custom posting records as well
          customPostingRecords.forEach((e) => {
            e.customValues = JSON.parse(e.customValues);
            if (e.searchableField !== undefined) {
              e.searchableField = Number(e.searchableField);
            }
            if (e.mandatory !== undefined) {
              e.mandatory = Number(e.mandatory);
            }
          });
          let finalPostingObj = [
            ...customPostingRecords.reverse(),
            ...postingObj.reverse(),
          ];
          setCustomPostingsFeilds(finalPostingObj);
          // ================== APPLICANTS ==================
          let applicantsRecords = myData.filter(
            (x) => parseInt(x.moduleId) === 2
          );
          let defaultApplicantsRecords = applicantsRecords.filter(
            (x) => x.fieldType === 'default'
          );
          let customApplicantsRecords = applicantsRecords.filter(
            (x) => x.fieldType === 'custom'
          );
          let hash1 = Object.create(null);
          const uniqueDefaultApplicantRecords = defaultApplicantsRecords.reduce(
            function (r, o) {
              if (!(o.fieldName in hash1)) {
                hash1[o.fieldName] = r.push(o) - 1;
                return r;
              }
              if (o.id > r[hash1[o.fieldName]].id) {
                r[hash1[o.fieldName]] = o;
              }
              return r;
            },
            []
          );

          let applicantObj = JSON.parse(JSON.stringify(defaultApplicantsData));
          uniqueDefaultApplicantRecords.forEach((list) => {
            let index = applicantObj.findIndex(
              (x) => x.fieldName === list.fieldName
            );
            if (index !== -1) {
              applicantObj[index].customValues = JSON.parse(list.customValues);
              applicantObj[index].id = Number(list.id);

              if (list.searchableField !== undefined) {
                applicantObj[index].searchableField = Number(
                  list.searchableField
                );
              }

              if (list.mandatory !== undefined) {
                applicantObj[index].mandatory = Number(list.mandatory);
              }
            }
          });
          // normalize custom applicant records too
          customApplicantsRecords.forEach((e) => {
            e.customValues = JSON.parse(e.customValues);
            if (e.searchableField !== undefined) {
              e.searchableField = Number(e.searchableField);
            }
            if (e.mandatory !== undefined) {
              e.mandatory = Number(e.mandatory);
            }
          });
          let finalApplicantsObj = [
            ...customApplicantsRecords.reverse(),
            ...applicantObj.reverse(),
          ];
          setCustomApplicantsFeilds(finalApplicantsObj);

          // ================== clients ==================
          let clientsRecords = myData.filter((x) => parseInt(x.moduleId) === 3);
          if (clientsRecords.length > 0) {
            clientsRecords.forEach((e) => {
              e.customValues = JSON.parse(e.customValues);
              if (e.searchableField !== undefined) {
                e.searchableField = Number(e.searchableField);
              }
              if (e.mandatory !== undefined) {
                e.mandatory = Number(e.mandatory);
              }
            });
            setCustomClientsFeilds(clientsRecords.reverse());
          }
        } else {
          dispatch(updateLoader(false));
          setCustomPostingsFeilds(
            JSON.parse(JSON.stringify(defaultPostingsData))
          );
          setCustomApplicantsFeilds(
            JSON.parse(JSON.stringify(defaultApplicantsData))
          );
        }
      } else {
        setCustomPostingsFeilds(
          JSON.parse(JSON.stringify(defaultPostingsData))
        );
        setCustomApplicantsFeilds(
          JSON.parse(JSON.stringify(defaultApplicantsData))
        );
        dispatch(updateLoader(false));
        dispatch(updateSnackbar({ type: 'error', message: '' }));
      }
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      dispatch(updateLoader(false));
    }
  };

  const deleteRecords = async (id) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    try {
      const deleteJobPost = await deleteApi(
        `/mgmt/customer/customfields/${id}?atsAdmin=true`,
        {},
        process.env.REACT_APP_USE_MANAGEMENT
      );
      const jsonData = deleteJobPost.data;
      dispatch(
        updateSnackbar({
          type: jsonData.code === 200 ? 'success' : 'error',
          message: jsonData.message,
        })
      );
      setTimeout(() => {
        fetchData(getUserId);
      }, 2000);
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      dispatch(updateLoader(false));
    }
  };

  const updateRecord = async (obj) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    obj['customerId'] = getUserId;
    try {
      const postData = await putApi(
        `/mgmt/customer/customfields/${obj.id}?atsAdmin=true`,
        obj,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      let res = postData.data;
      dispatch(
        updateSnackbar({
          type: res.code === 200 ? 'success' : 'error',
          message: res.message,
        })
      );
      setTimeout(() => {
        dispatch(updateSnackbar(initialSnackbar));
        dispatch(updateLoader(false));
        fetchData(getUserId);
      }, 2000);
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      dispatch(updateLoader(false));
    }
  };

  const addRecord = async (obj) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    obj['customerId'] = getUserId;
    try {
      const postData = await postApi(
        `/mgmt/customer/customfields?atsAdmin=true`,
        obj,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      let res = postData.data;
      dispatch(
        updateSnackbar({
          type: res.code === 200 ? 'success' : 'error',
          message: 'Custom field added successfully',
        })
      ); //res.message
      setTimeout(() => {
        dispatch(updateSnackbar(initialSnackbar));
        dispatch(updateLoader(false));
        fetchData(getUserId);
      }, 2000);
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      dispatch(updateLoader(false));
    }
  };

  const onTableData = (data, index) => {
    let Array = data;
    if (Array !== null) {
      if (Array[index].id === 0) {
        delete Array[index].id;
      }
      if (Array[index].id === undefined) {
        addRecord(Array[index]);
      } else {
        updateRecord(Array[index]);
      }
      // write condition here!
      // setCustomPostingsFeilds(Array)
      // setCustomApplicantsFeilds(Array)
    } else {
      deleteRecords(index);
    }
  };

  const onChangeModule = (type) => {
    setModuleType(type);
  };

  return (
    <>
      <div id="customdynamictable" className="customgroupButtons">
        <ButtonGroup variant="contained">
          {CustomFeildsModuleTypes.map((module) => (
            <Button
              key={module.id}
              className={moduleType === module.name ? 'active' : ''}
              onClick={() => onChangeModule(module.name)}
            >
              {module.name}
            </Button>
          ))}
        </ButtonGroup>
      </div>
      <div id="dynamicTableSection" style={{ marginTop: '-12px' }}>
        {moduleType === 'Job Postings' && customPostingsFeilds.length > 0 ? (
          <CustomDynamicTable
            moduleType="Job Postings"
            columns={customColoumn}
            data={customPostingsFeilds}
            receiveProps={onTableData}
          />
        ) : moduleType === 'Applicants' && customApplicantsFeilds.length > 0 ? (
          <CustomDynamicTable
            moduleType="Applicants"
            columns={applicantsCustomColoumn}
            data={customApplicantsFeilds}
            receiveProps={onTableData}
          />
        ) : moduleType === 'Clients' ? (
          <CustomDynamicTable
            moduleType="Clients"
            columns={clientsCustomColoumn}
            data={customClientsFeilds}
            receiveProps={onTableData}
          />
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default Custom;

const CustomFeildsModuleTypes = [
  { id: 1, name: 'Job Postings' },
  { id: 2, name: 'Applicants' },
  { id: 3, name: 'Clients' },
];

const customColoumn = [
  // { id: 1, displayName: "Module", name: "moduleId" },
  { id: 1, displayName: 'Field Name', name: 'fieldName' },
  { id: 2, displayName: 'Data Type', name: 'dataType' },
  { id: 3, displayName: 'Values', name: 'customValues' },
  { id: 4, displayName: 'Mandatory', name: 'mandatory' },
  { id: 5, displayName: 'Action', name: 'action' },
];

const applicantsCustomColoumn = [
  { id: 1, displayName: 'Field Name', name: 'fieldName' },
  { id: 2, displayName: 'Data Type', name: 'dataType' },
  { id: 3, displayName: 'Values', name: 'customValues' },
  { id: 4, displayName: 'Searchable Field', name: 'searchableField' },
  { id: 5, displayName: 'Mandatory', name: 'mandatory' },
  { id: 6, displayName: 'Action', name: 'action' },
];

const clientsCustomColoumn = [
  { id: 1, displayName: 'Field Name', name: 'fieldName' },
  { id: 2, displayName: 'Data Type', name: 'dataType' },
  { id: 3, displayName: 'Values', name: 'customValues' },
  { id: 4, displayName: 'Mandatory', name: 'mandatory' },
  { id: 5, displayName: 'Action', name: 'action' },
];

const defaultPostingsData = [
  {
    id: 1,
    moduleId: 1,
    fieldName: 'Work model',
    fieldType: 'default',
    dataType: 'Single select',
    customValues: ['Hybrid', 'On-site', 'Remote'],
    action: 'action',
    mandatory: 1,
  },
  {
    id: 2,
    moduleId: 1,
    fieldName: 'Job status',
    fieldType: 'default',
    dataType: 'Single select',
    customValues: ['Closed', 'Filled', 'Active', 'On-Hold'],
    action: 'action',
    mandatory: 1,
  },
  {
    id: 3,
    moduleId: 1,
    fieldName: 'Job type',
    fieldType: 'default',
    dataType: 'Single select',
    customValues: ['Full time', 'Part time', 'Intern', 'Contract'],
    action: 'action',
    mandatory: 1,
  },
  {
    id: 4,
    moduleId: 1,
    fieldName: 'Priority',
    fieldType: 'default',
    dataType: 'Single select',
    customValues: ['High', 'Medium', 'Low'],
    action: 'action',
    mandatory: 0,
  },
];

const defaultApplicantsData = [
  {
    id: 1,
    moduleId: 2,
    fieldName: 'Source',
    fieldType: 'default',
    dataType: 'Single select',
    searchableField: 0,
    mandatory: 1,
    customValues: [
      'Cloud Sourcing',
      'Employee Portal',
      'Vendor Sourcing',
      'Job Board Portal',
      'LinkedIn',
      'Indeed',
      'Zoho Recruit',
      'Zip Recruit',
      'Monster',
      'Social Media',
      'Ceipal',
      'Reference',
      'Career Builder',
      'Others',
    ],
    action: 'action',
  },
  {
    id: 2,
    moduleId: 2,
    fieldName: 'Candidate status',
    fieldType: 'default',
    dataType: 'Single select',
    searchableField: 0,
    mandatory: 1,
    customValues: [
      'Associated',
      'Pending',
      'Rejected',
      'New',
      'Assigned',
      'Consent await',
      'Submitted',
      'Interview',
      'Selected',
    ],
    action: 'action',
  },
  {
    id: 3,
    moduleId: 2,
    fieldName: 'Document type',
    fieldType: 'default',
    dataType: 'Single select',
    searchableField: 0,
    mandatory: 1,
    customValues: ['Resume', 'Cover letter', 'ID Proof'],
    action: 'action',
  },
];
